import { useTheme } from 'foundations-theming/utils';
import { FullScreen } from 'foundations-components/transitional/components/FullScreen';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { APP_STATUS } from 'ContentEditorUI/redux/constants';
import { isInOnboardingSession } from 'onboarding-tours/util/bannerFrame';
import { EditorPage } from 'foundations-components/transitional/components/EditorPage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullScreenEditorWrapper = ({
  appStatus,
  children,
  headerComponent,
  tabBarComponent
}) => {
  const maybeGlobalLoadingOverlay = appStatus === APP_STATUS.LOADING ? /*#__PURE__*/_jsx(LoadingOverlay, {}) : null;
  const theme = useTheme();
  const isOnboardingBannerActive = !!isInOnboardingSession();
  return /*#__PURE__*/_jsx(FullScreen, {
    children: /*#__PURE__*/_jsxs(View, {
      blockSize: isOnboardingBannerActive ? 'calc(100vh - 55px)' : '100vh',
      children: [/*#__PURE__*/_jsx(EditorPage, {
        id: "editor-page",
        mainSectionFlush: true,
        hasScrolling: false,
        headerComponent: headerComponent,
        mainBackgroundColor: theme.color['fill-surface-default'],
        tabs: tabBarComponent,
        headerWrapperStyles: {
          zIndex: 10
        },
        children: children
      }), maybeGlobalLoadingOverlay]
    })
  });
};
export default FullScreenEditorWrapper;